// @ts-check
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { updateHistoryState } from '~/other/Helper';

/**
 * Custom hook to store data in history state before navigation
 * @param {() => object} getDataToStore - Function that returns the data to store
 * @param {any[]} dependencies - Dependencies to watch for changes
 */
export default function useHistoryStateStore(getDataToStore, dependencies = []) {
    const history = useHistory();
    
    useEffect(() => {
        const unblock = history.block((location, action) => {
            if (action === 'REPLACE') {
                return true;
            }
            const dataToStore = typeof getDataToStore === 'function' ? getDataToStore() : getDataToStore;
            updateHistoryState(history, dataToStore);
            return true;
        });
        
        return unblock;
    }, [history, getDataToStore, ...dependencies]);
}

